<!-- Modal (Notas Fiscais (Sintéticas)) -->

<ng-template #notasFiscaisSinteticas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-notas-fiscais-sinteticas"><b>Notas fiscais e duplicatas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-pedido-modal-notas-fiscais [notasFiscais]="notasFiscais"></app-pedido-modal-notas-fiscais>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Selecionar (Lote)) -->

<ng-template #selecionarLote let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-selecionar-lote"><b>Selecionar Lote</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Produto:</b></label>

        <input class="form-control form-control-sm" type="text" name="produto_selecionado" [value]="produtoSelecionado == null ? '' : produtoSelecionado.name" disabled />
      </div>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th>Nome</th>
            <th class="text-center tabela_borda">Estoque</th>
            <th class="text-center tabela_borda">Validade</th>
            <th class="text-right tabela_borda">Unitário: R$</th>
          </tr>
        </thead>

        <tbody>
          @for (produtoLote of produtosLotes; track produtoLote) {
            <tr class="tabela_linha_acao" (click)="selecionarLoteProduto(produtoLote.id)">
              <td>{{ produtoLote.nomelote }}</td>
              <td class="text-center tabela_borda">{{ produtoLote.estoque }}</td>
              <td class="text-center tabela_borda">{{ produtoLote.validade | date: 'dd/MM/yyyy' }}</td>
              <td class="text-right tabela_borda">{{ produtoLote.preco | currency: 'BRL' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
  </div>
</ng-template>

<!-- Modal (Produtos Selecionados para Importação em Massa) -->

<ng-template #produtosAdicionadosEmMassaModal let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-produtos-adicionados-em-massa"><b>Produtos Selecionados para Importação ({{ produtosSelecionadosEmMassa.size }})</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    @if (produtosSelecionadosEmMassa.size === 0) {
      <div class="alert alert-info">
        Nenhum produto selecionado.
      </div>
    }

    @if (produtosSelecionadosEmMassa.size > 0) {
      <div class="table-responsive">
        <table class="table table-sm table-hover">
          <thead>
            <tr>
              <th></th>
              <th class="text-center tabela_borda">Código</th>
              <th class="tabela_borda">Descrição</th>
              <th class="text-right tabela_borda">Preço Base: R$</th>
            </tr>
          </thead>
          <tbody>
            @for (produto of produtosSelecionadosDetalhes; track trackByProdutoId($index, produto)) {
              <tr>
                <td class="text-center tabela_acao">
                  <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Desselecionar" (click)="selecionarProdutoEmMassa(produto.id)"></i>
                </td>
                <td class="text-center tabela_borda">{{ produto.codigo }}</td>
                <td class="tabela_borda">{{ produto.name }}</td>
                <td class="text-right tabela_borda">{{ (produto.price > 0 ? produto.price : produto.custo) | currency: 'BRL' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Fechar')">Fechar</button>
  </div>
</ng-template>

<!-- Modal: Conferência da Importação via Planilha -->
<ng-template #modalImportacaoPlanilha let-modal>
  <div class="modal-header">
    <h3 class="modal-title" id="titulo-importacao-planilha"><b>Conferência da Importação ({{ linhasImportacao.length }} linha(s))</b></h3>
    <button type="button" class="close" aria-label="Fechar" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-2">
      <span class="badge badge-success mr-2">{{ importacaoLinhasValidas }} válida(s)</span>
      <span class="badge badge-danger">{{ importacaoLinhasInvalidas }} com erro</span>
    </div>
    <div class="table-responsive" style="max-height: 60vh; overflow-y: auto;">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th class="text-center">Linha</th>
            <th>Código</th>
            <th>Descrição</th>
            <th class="text-right">Preço base</th>
            <th class="text-center">Tipo</th>
            <th class="text-right">%</th>
            <th class="text-right">Preço</th>
            <th class="text-right">Margem</th>
            <th class="text-center">Qtde mín.</th>
            <th class="text-center">Cota</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          @for (linha of linhasImportacao; track linha.linha) {
            <tr [ngClass]="{ 'table-danger': !linha.valido }">
              <td class="text-center">{{ linha.linha }}</td>
              <td>{{ linha.codigo }}</td>
              <td>{{ linha.nome }}</td>
              <td class="text-right">{{ linha.preco_base | currency: 'BRL' }}</td>
              <td class="text-center">{{ linha.tipo_calculo === 'margem' ? 'Margem' : 'Desconto' }}</td>
              <td class="text-right">{{ linha.percentual | number: '1.2-2' }}%</td>
              <td class="text-right">{{ linha.preco | currency: 'BRL' }}</td>
              <td class="text-right">{{ linha.margem != null ? (linha.margem | number: '1.2-2') + '%' : '—' }}</td>
              <td class="text-center">{{ linha.qtd_minima }}</td>
              <td class="text-center">{{ linha.cota_total != null ? linha.cota_total : '—' }}</td>
              <td class="text-center">
                @if (linha.valido) {
                  <span class="badge badge-success">OK</span>
                } @else {
                  <span class="badge badge-danger" [ngbTooltip]="linha.erro">Erro</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    @if (importacaoLinhasInvalidas > 0) {
      <small class="text-muted">As linhas com erro serão ignoradas; apenas as válidas serão importadas.</small>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-success" (click)="confirmarImportacaoPlanilha(modal)"
      [disabled]="importacaoLinhasValidas === 0">
      ✓ Importar {{ importacaoLinhasValidas }} válida(s)
    </button>
  </div>
</ng-template>

<div class="container-fluid p-0">
  <!-- Título -->

  @if (!carregando) {
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4" [@esvanecerDesvanecer]="'in'">
      @if (produtoTabelaEspecial == null) {
        <div class="titulo_texto">{{ naoAplicaFatorPontuacaoFinGlobal ? 'Nova Tabela Especial' : 'Nova Promoção' }}</div>
      }
      @if (produtoTabelaEspecial != null) {
        <div class="titulo_texto">{{ naoAplicaFatorPontuacaoFinGlobal ? 'Alterar Tabela Especial' : 'Alterar Promoção' }}</div>
      }
    </div>
  }

  @if (!carregando) {
    <div [@esvanecerDesvanecer]="'in'">
      <!-- Itens (Menu) -->
      <div class="pt-3 pr-4 pb-0 pl-4">
        <div class="d-flex flex-wrap justify-content-center itens_menu" [class.menu-com-prazos]="regraPrazoHabilitada">
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 0) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(0)">
            1. Informações
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 1) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(1)">
            2. Produtos
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 2) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(2)">
            3. Clientes
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 3) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(3)">
            4. Vendedores
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 4) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(4)">
            5. Regras de Grupo
          </div>
          @if (regraPrazoHabilitada) {
            <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 5) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(5)">6. Regra de Prazo</div>
          }
        </div>
        <hr class="mt-2 mb-2" />
      </div>
      @if (itemSelecionado == 5 && regraPrazoHabilitada) {
        <div class="pr-4 pb-4 pl-4">
          <div class="d-flex flex-wrap justify-content-between">
            <div class="flex-grow-1 formulario_rodape"><button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(5)">Retornar</button></div>
            <div class="flex-grow-1 formulario_rodape text-right"><button class="btn btn-success btn_formulario btn_formulario_save" type="button" (click)="salvarProdutoTabelaEspecial()">Salvar ({{ eTabelaEspecial ? 'Tabela Especial' : 'Promoção' }})</button></div>
          </div>
          <hr class="mt-2 mb-2" />
          <h6 class="font-weight-bold">Regra de Prazo</h6>
          <p class="text-muted">Vincule os prazos de pagamento a esta promoção / tabela especial.</p>
          <div class="form-row align-items-end mb-3">
            <div class="col-sm-6"><label for="regra-prazo"><b>Prazo de pagamento</b></label><select id="regra-prazo" class="form-control form-control-sm" [(ngModel)]="prazoSelecionado" [disabled]="prazosCarregando"><option [ngValue]="null">{{ prazosCarregando ? 'Carregando prazos…' : 'Selecione um prazo…' }}</option>@for (p of prazosDisponiveis; track p.idprazopagamento) {<option [ngValue]="p.idprazopagamento">{{ p.descricao }} ({{ p.idprazopagamento }})</option>}</select></div>
            <div class="col-sm-auto mt-2"><button class="btn btn-primary btn-sm" type="button" (click)="adicionarPrazo()" [disabled]="!prazoSelecionado || prazosCarregando"><i class="fa fa-plus" aria-hidden="true"></i> Adicionar</button></div>
          </div>
          <div class="table-responsive"><table class="table table-sm"><thead><tr><th>Código</th><th>Prazo de pagamento</th><th class="text-right">Ações</th></tr></thead><tbody>
            @for (id of prazosVinculados; track id) {<tr><td>{{ id }}</td><td>{{ descricaoPrazo(id) }}</td><td class="text-right"><button class="btn btn-outline-danger btn-sm" type="button" (click)="removerPrazo(id)" [attr.aria-label]="'Remover prazo ' + id"><i class="fa fa-trash" aria-hidden="true"></i> Remover</button></td></tr>}
            @if (!prazosVinculados.length) {<tr><td colspan="3" class="text-center text-muted">Nenhum prazo vinculado. A promoção / tabela especial não possui restrição de prazo.</td></tr>}
          </tbody></table></div>
          <small class="text-muted">{{ prazosVinculados.length }} prazo(s) vinculado(s)</small>
        </div>
      }
      <!-- Informações -->
      @if (itemSelecionado == 0) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <!-- Formulário (Tabela Especial) -->
          <form [formGroup]="formProdutoTabelaEspecial">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label><b>Nome:</b></label>
                <input class="form-control form-control-sm" type="text" name="nome" [ngClass]="{ 'is-invalid': enviadoProdutoTabelaEspecial && fta.nome.errors?.required }" formControlName="nome" />
                @if (enviadoProdutoTabelaEspecial && fta.nome.errors?.required) {
                  <div class="erro pt-1">Nome em branco!</div>
                }
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-4">
                <label><b>Ativo:</b></label>
                <select class="form-control form-control-sm" name="ativo" #ativo (change)="selecionarProdutoTabelaEspecialAtivo(ativo.value)">
                  <option value="0" [selected]="!produtoTabelaEspecialAtivo">Não</option>
                  <option value="1" [selected]="produtoTabelaEspecialAtivo">Sim</option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-4">
                <label><b>Data de Início:</b></label>
                <input type="date" class="form-control form-control-sm" formControlName="dt_inicio" />
              </div>
              <div class="form-group col-sm-4">
                <label><b>Data de Fim:</b></label>
                <input type="date" class="form-control form-control-sm" formControlName="dt_fim" />
              </div>
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <div class="d-flex justify-content-end">
            <button class="btn btn-secondary btn_formulario" type="button" (click)="prosseguirItemSelecionado(0)">Prosseguir</button>
            <button class="btn btn-success btn_formulario btn_formulario_save" type="button" (click)="salvarProdutoTabelaEspecial()">Salvar (Promoção)</button>
          </div>
        </div>
      }
      <!-- Produtos -->
      @if (itemSelecionado == 1) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <div class="d-flex flex-wrap justify-content-between">
            <div class="flex-grow-1 formulario_rodape">
              <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(1)">Retornar</button>
            </div>
            <div class="flex-grow-1 formulario_rodape text-right">
              @if (produtoTabelaEspecial != null) {
              <button class="btn btn-secondary btn_formulario" type="button" (click)="prosseguirItemSelecionado(1)">Prosseguir</button>
              }
              <button class="btn btn-success btn_formulario btn_formulario_save" type="button" (click)="salvarProdutoTabelaEspecial()">Salvar (Promoção)</button>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
          <!-- Buscar (Produto) - Múltiplos Filtros -->
          <form [formGroup]="formFiltroProduto" (ngSubmit)="adicionarFiltro()">
            <div class="form-row">
              <div class="form-group col-sm-2">
                <label class="text-secondary"><b>Filtrar por:</b></label>
                <select class="form-control form-control-sm" name="filtrar_produto_por" formControlName="filtro" (change)="alterarFiltroProduto($event.target.value)">
                  @for (opcao of filtroProdutos; track opcao) {
                    <option [value]="opcao.valor">{{ opcao.texto }}</option>
                  }
                </select>
              </div>
              <!-- Campo de Valor (Dinâmico) -->
              <div class="form-group col-sm-5">
                <label class="text-secondary"><b>Valor:</b></label>
                <!-- Entrada para Código e Descrição -->
                @if (ffp.filtro.value !== 'marca' && ffp.filtro.value !== 'subgrupo1' && ffp.filtro.value !== 'subgrupo2' && ffp.filtro.value !== 'subgrupo3' && ffp.filtro.value !== 'subgrupo4' && ffp.filtro.value !== 'subgrupo5') {
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    name="produto_valor"
                    [ngClass]="{ 'is-invalid': enviadoProduto && ffp.valor.errors?.required }"
                    formControlName="valor"
                    placeholder="Digite o valor" />
                }
                <!-- Select para Marca (dinâmico) -->
                @if (ffp.filtro.value === 'marca') {
                  <select
                    class="form-control form-control-sm"
                    name="produto_marca"
                    [ngClass]="{ 'is-invalid': enviadoProduto && ffp.valor.errors?.required }"
                    formControlName="valor">
                    <option value="">-- Selecione uma marca --</option>
                    @for (marca of marcasDisponiveis; track marca) {
                      <option [value]="marca">{{ marca }}</option>
                    }
                  </select>
                }
                <!-- Select para Subgrupo 1 (dinâmico) -->
                @if (ffp.filtro.value === 'subgrupo1') {
                  <select
                    class="form-control form-control-sm"
                    name="produto_subgrupo1"
                    [ngClass]="{ 'is-invalid': enviadoProduto && ffp.valor.errors?.required }"
                    formControlName="valor">
                    <option value="">-- Selecione um subgrupo 1 --</option>
                    @for (subgrupo of subgrupos1Disponiveis; track subgrupo) {
                      <option [value]="subgrupo">{{ subgrupo }}</option>
                    }
                  </select>
                }
                <!-- Select para Subgrupo 2 (dinâmico) -->
                @if (ffp.filtro.value === 'subgrupo2') {
                  <select
                    class="form-control form-control-sm"
                    name="produto_subgrupo2"
                    [ngClass]="{ 'is-invalid': enviadoProduto && ffp.valor.errors?.required }"
                    formControlName="valor">
                    <option value="">-- Selecione um subgrupo 2 --</option>
                    @for (subgrupo of subgrupos2Disponiveis; track subgrupo) {
                      <option [value]="subgrupo">{{ subgrupo }}</option>
                    }
                  </select>
                }
                <!-- Select para Subgrupo 3 (dinâmico) -->
                @if (ffp.filtro.value === 'subgrupo3') {
                  <select
                    class="form-control form-control-sm"
                    name="produto_subgrupo3"
                    [ngClass]="{ 'is-invalid': enviadoProduto && ffp.valor.errors?.required }"
                    formControlName="valor">
                    <option value="">-- Selecione um subgrupo 3 --</option>
                    @for (subgrupo of subgrupos3Disponiveis; track subgrupo) {
                      <option [value]="subgrupo">{{ subgrupo }}</option>
                    }
                  </select>
                }
                <!-- Select para Subgrupo 4 (dinâmico) -->
                @if (ffp.filtro.value === 'subgrupo4') {
                  <select
                    class="form-control form-control-sm"
                    name="produto_subgrupo4"
                    [ngClass]="{ 'is-invalid': enviadoProduto && ffp.valor.errors?.required }"
                    formControlName="valor">
                    <option value="">-- Selecione um subgrupo 4 --</option>
                    @for (subgrupo of subgrupos4Disponiveis; track subgrupo) {
                      <option [value]="subgrupo">{{ subgrupo }}</option>
                    }
                  </select>
                }
                <!-- Select para Subgrupo 5 (dinâmico) -->
                @if (ffp.filtro.value === 'subgrupo5') {
                  <select
                    class="form-control form-control-sm"
                    name="produto_subgrupo5"
                    [ngClass]="{ 'is-invalid': enviadoProduto && ffp.valor.errors?.required }"
                    formControlName="valor">
                    <option value="">-- Selecione um subgrupo 5 --</option>
                    @for (subgrupo of subgrupos5Disponiveis; track subgrupo) {
                      <option [value]="subgrupo">{{ subgrupo }}</option>
                    }
                  </select>
                }
                @if (enviadoProduto && ffp.valor.errors?.required) {
                  <div class="erro pt-1">Valor em branco!</div>
                }
              </div>
              <div class="col-sm-5 d-flex align-items-end gap-2">
                <button class="btn btn-success btn_filtro" type="button" (click)="adicionarFiltro()">+ Adicionar Filtro</button>
                <button class="btn btn-info btn_filtro" type="button" (click)="filtrarProduto()" [disabled]="filtrosAtivos.length === 0">
                  Aplicar {{ filtrosAtivos.length > 0 ? '(' + filtrosAtivos.length + ')' : '' }}
                </button>
                @if (filtrosAtivos.length > 0) {
                  <button class="btn btn-secondary btn_filtro" type="button" (click)="limparTodosFiltros()">Limpar</button>
                }
              </div>
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <!-- Cards de Filtros Ativos -->
          @if (filtrosAtivos.length > 0) {
            <div style="margin-bottom: 1rem;">
              <div class="gap-2">
                @for (filtro of filtrosAtivos; track filtro; let i = $index) {
                  <div class="badge badge-info w-auto">
                    <span><b>{{ obterTextoFiltro(filtro.tipo) }}:</b> {{ filtro.valor }}</span>
                    <button type="button" (click)="removerFiltro(i)"
                      style="background: none; border: none; color: white; cursor: pointer; padding: 0; margin-left: 0.5rem; font-size: 1rem; line-height: 1;">
                      ✕
                    </button>
                  </div>
                }
              </div>
            </div>
          }
          @if (filtrosAtivos.length > 0) {
            <hr class="mt-3 mb-2" />
          }
          @if (filtrandoProduto) {
            <div [@esvanecerDesvanecer]="'in'">
              <div class="filtrar_produto p-1">
                <div class="table-responsive h-100">
                  <cdk-virtual-scroll-viewport class="filtrar_produto_tabela" [itemSize]="20" minBufferPx="50" maxBufferPx="200">
                    <table class="table table-hover">
                      <thead class="sticky-top bg-white">
                        <tr>
                          <th class="text-center">
                            <input type="checkbox" class="produto-checkbox" [checked]="estaTodasSelecionadas()" (change)="selecionarTodosProdutos()" />
                          </th>
                          <th class="text-center">Código</th>
                          <th class="tabela_borda">Descrição</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *cdkVirtualFor="let produto of produtos; templateCacheSize: 0;">
                          <tr [ngClass]="{ 'produto-selecionado': estaProdutoSelecionadoEmMassa(produto.id) }" class="filtrar_produto_acao" [style.cursor]="'pointer'" (click)="selecionarProdutoEmMassa(produto.id)">
                            <td class="text-center" (click)="$event.stopPropagation()">
                              <input type="checkbox" class="produto-checkbox" [checked]="estaProdutoSelecionadoEmMassa(produto.id)" (change)="selecionarProdutoEmMassa(produto.id)" />
                            </td>
                            <td class="text-center">{{ produto.codigo }}</td>
                            <td class="tabela_borda">{{ produto.name }}</td>
                            <td class="text-center tabela_acao" (click)="$event.stopPropagation()">
                              <i class="fa fa-pencil btn_tabela_acao" placement="left" ngbTooltip="Selecionar individualmente" (click)="selecionarProdutoFiltrado(produto.id)"></i>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </cdk-virtual-scroll-viewport>
                </div>
              </div>
              <hr class="mt-2 mb-2" />
              <!-- Seção de Importação em Massa -->
              <div class="mb-3">
                <div class="d-flex justify-content-between mb-2">
                  @if (produtosSelecionadosEmMassa.size > 0) {
                    <button class="btn btn-warning btn_formulario" type="button" (click)="abrirModalProdutosAdicionadosEmMassa(produtosAdicionadosEmMassaModal)">
                      👁️ Visualizar ({{ produtosSelecionadosEmMassa.size }}) Selecionado(s)
                    </button>
                  }
                </div>
                <div class="alert alert-info p-3 mb-3">
                  <div class="form-row">
                    <div class="form-group col-sm-2">
                      <label><b>Tipo:</b></label>
                      <select class="form-control form-control-sm" [(ngModel)]="tipoCalculo">
                        <option value="margem">Margem (%)</option>
                        <option value="desconto">Desconto (%)</option>
                      </select>
                    </div>
                    <div class="form-group col-sm-2">
                      <label><b>Percentual:</b></label>
                      <input class="form-control form-control-sm" type="number" [(ngModel)]="percentualProdutos" placeholder="Ex: 10" />
                    </div>
                    <div class="form-group col-sm-2">
                      <label><b>Qtde Mínima:</b></label>
                      <input class="form-control form-control-sm" type="number" [(ngModel)]="quantidadeMinimaProdutos" placeholder="Ex: 0" />
                    </div>
                    <div class="form-group col-sm-6 d-flex align-items-end">
                      <button class="btn btn-success btn_formulario mr-2" type="button" (click)="importarProdutosSelecionados()" [disabled]="produtosSelecionadosEmMassa.size === 0">
                        ✓ Importar {{ produtosSelecionadosEmMassa.size }} Produto(s)
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <!-- Importação via Planilha (Excel) — sempre disponível (fora do @if de filtro de produto) -->
          <div class="alert alert-secondary p-3 mb-0 mt-2">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0"><b>📄 Importar Promoções via Planilha</b></h6>
              <button class="btn btn-outline-secondary btn-sm" type="button" (click)="baixarModeloImportacao()">
                ⬇️ Baixar modelo
              </button>
            </div>
            <small class="text-muted d-block mb-2">
              Preencha <b>codigo</b> e, por linha, informe o <b>preco_venda</b> (prevalece) <b>ou</b> o <b>tipo</b> (margem/desconto) + <b>percentual</b>. O preço, percentual e margem são calculados automaticamente.
            </small>
            <div class="form-row align-items-end">
              <div class="form-group col-sm-6 mb-0">
                <input class="form-control form-control-sm" type="file" accept=".xlsx,.xls"
                  (change)="onArquivoImportacaoSelecionado($event)" />
              </div>
              <div class="form-group col-sm-6 mb-0">
                <button class="btn btn-primary btn_formulario" type="button"
                  (click)="processarImportacaoPlanilha()"
                  [disabled]="arquivoImportacao == null || importandoPlanilha">
                  @if (importandoPlanilha) { ⏳ Processando... } @else { 📥 Processar planilha }
                </button>
              </div>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
          <!-- Formulário (Tabela Especial (Itens)) -->
          @if (produtoSelecionado != null) {
            <form [formGroup]="formProdutoTabelaEspecialItem">
              <div class="form-row">
                <div class="form-group col-sm-2">
                  <label><b>Código:</b></label>
                  <input class="form-control form-control-sm" type="text" name="codigo" [value]="produtoSelecionado.codigo" [ngClass]="{ 'is-invalid': produtoEmBranco || produtoInvalido }" disabled />
                </div>
                <div class="form-group col-sm-10">
                  <label><b>Descrição:</b></label>
                  <input class="form-control form-control-sm" type="text" name="descricao" [value]="produtoSelecionado.name" [ngClass]="{ 'is-invalid': produtoEmBranco || produtoInvalido }" disabled />
                  @if (produtoEmBranco) {
                    <div class="erro pt-1">Produto em branco!</div>
                  }
                  @if (produtoInvalido) {
                    <div class="erro pt-1">Produto inválido!</div>
                  }
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-sm-2">
                  <label><b>Ativo:</b></label>
                  <select class="form-control form-control-sm" name="ativo_item" #ativo_item (change)="selecionarProdutoTabelaEspecialItemAtivo(ativo_item.value)">
                    <option value="0" [selected]="!produtoTabelaEspecialItemAtivo">Não</option>
                    <option value="1" [selected]="produtoTabelaEspecialItemAtivo">Sim</option>
                  </select>
                </div>
                @if (produtoSelecionado.qtde_lote > 0) {
                  <div class="form-group col-sm-2">
                    <label>
                      <b>Lote:</b>
                      <i class="fa fa-search-plus label_acao ml-2" placement="top" ngbTooltip="Selecionar" (click)="modalSelecionarLote(selecionarLote, produtoSelecionado.id)"></i>
                    </label>
                    <input class="form-control form-control-sm" type="text" name="nome_lote" [ngClass]="{ 'is-invalid': produtoLoteErro }" [value]="produtoSelecionado.nome_lote" disabled />
                    @if (produtoLoteErro) {
                      <div class="erro pt-1">Lote em branco!</div>
                    }
                  </div>
                }
                <div class="form-group col-sm-2">
                  <label><b>Qtde:</b></label>
                  <div class="d-flex align-items-center">
                    <i class="fa fa-minus produto_selecionado_qtde_acao pr-2" (click)="decrementarQtdeProduto()"></i>
                    <input class="form-control form-control-sm" type="number" min="1" step="1" name="qtde" [ngClass]="{ 'is-invalid': fti.qtde.errors?.invalid }" (focusout)="verificarProdutoQtde()" formControlName="qtde" />
                    <i class="fa fa-plus produto_selecionado_qtde_acao pl-2" (click)="incrementarQtdeProduto()"></i>
                  </div>
                  @if (produtoSelecionado.multiplo != null && produtoSelecionado.multiplo != 0 && produtoSelecionado.multiplo != 1) {
                    <div class="aviso pt-1">Múltipla de {{ produtoSelecionado.multiplo }}...</div>
                  }
                  @if (fti.qtde.errors?.invalid) {
                    <div class="erro pt-1">Qtde inválida!</div>
                  }
                </div>
                <div class="form-group col-sm-2">
                  <label><b>Preço (Atual): R$</b></label>
                  <input class="form-control form-control-sm" type="text" name="preco_atual" [value]="produtoSelecionado.valor | currency: 'BRL' : ''" disabled />
                </div>
                <div class="form-group col-sm-2">
                  <label><b>Custo Atual: R$</b></label>
                  <input class="form-control form-control-sm" type="text" name="custo_atual" [value]="(produtoSelecionado.custo != null ? (produtoSelecionado.custo | currency: 'BRL' : '') : '—')" disabled />
                </div>
                <div class="form-group col-sm-2">
                  <label><b>Preço: R$</b></label>
                  <input class="form-control form-control-sm" type="number" min="0" step="0.01" name="preco" [ngClass]="{ 'is-invalid': enviadoProdutoTabelaEspecialItem && (fti.preco.errors?.required || fti.preco.errors?.invalid) }" formControlName="preco" />
                  @if (enviadoProdutoTabelaEspecialItem && fti.preco.errors?.required) {
                    <div class="erro pt-1">Preço em branco!</div>
                  }
                  @if (enviadoProdutoTabelaEspecialItem && fti.preco.errors?.invalid) {
                    <div class="erro pt-1">Preço inválido!</div>
                  }
                </div>
                <div class="form-group col-sm-2">
                  <label><b>Cota (un.):</b></label>
                  <input class="form-control form-control-sm" type="number" min="0" step="1" name="cota"
                    formControlName="cota" placeholder="Sem limite" />
                  <small class="text-muted">Vazio = sem limite</small>
                </div>
                <div class="form-group col-sm-2">
                  <label><b>Margem (%):</b></label>
                  <input class="form-control form-control-sm" type="text" name="margem_calculada"
                    [value]="margemCalculada != null ? (margemCalculada | number: '1.2-2') + '%' : '—'"
                    [ngClass]="{ 'text-danger': margemCalculada != null && margemCalculada < 0, 'text-success': margemCalculada != null && margemCalculada >= 0 }"
                    disabled />
                </div>
              </div>
              <hr class="mt-2 mb-2" />
              <div class="d-flex justify-content-end">
                <button class="btn btn-success btn_formulario" type="button" (click)="salvarProdutoTabelaEspecialItem()">Salvar (Produto)</button>
                @if (produtoTabelaEspecialItemSelecionado != null) {
                  <button class="btn btn-secondary btn_formulario" type="button" (click)="reiniciarProdutoTabelaEspecialItem()">Cancelar</button>
                }
              </div>
            </form>
          }
          <hr class="mt-2 mb-2" />
          <!-- Produto (Tabela Especial (Itens)) - COMPONENTE EDITÁVEL -->
          <div class="mb-3 d-flex flex-wrap align-items-center justify-content-between">
            <h5 class="mb-2 mr-3"><b>Produtos Importados</b></h5>
            <div class="d-flex align-items-center mb-2">
              <label for="filtro-ativo-importados" class="mb-0 mr-2">Ativo:</label>
              <select id="filtro-ativo-importados" class="form-control form-control-sm w-auto"
                [(ngModel)]="filtroAtivoImportados" [ngModelOptions]="{standalone: true}">
                <option value="ativo">Ativo</option>
                <option value="inativo">Inativo</option>
                <option value="todos">Todos</option>
              </select>
            </div>
          </div>
          <app-tabela-produtos-editavel
            [produtos]="produtosTabelaEspecialItens"
            [filtroAtivo]="filtroAtivoImportados"
            [exibirLote]="exibirLote"
            (editarItem)="selecionarProdutoTabelaEspecialItem($event.codigo, $event.qtd_minima)"
            (verLogItem)="abrirLogItem($event)">
          </app-tabela-produtos-editavel>
        </div>
      }
      <!-- Clientes -->
      @if (itemSelecionado == 2) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <div class="d-flex flex-wrap justify-content-between">
            <div class="flex-grow-1 formulario_rodape">
              <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(2)">Retornar</button>
            </div>
            <div class="flex-grow-1 formulario_rodape text-right">
              <button class="btn btn-secondary btn_formulario" type="button" (click)="prosseguirItemSelecionado(2)">Prosseguir</button>
              <button class="btn btn-success btn_formulario btn_formulario_save" type="button" (click)="salvarProdutoTabelaEspecial()">Salvar (Promoção)</button>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
          <!-- Buscar (Cliente) - Múltiplos Filtros -->
          <form [formGroup]="formFiltroCliente" (ngSubmit)="adicionarFiltroCliente()">
            <div class="form-row">
              <div class="form-group col-sm-2">
                <label class="text-secondary"><b>Filtrar por:</b></label>
                <select class="form-control form-control-sm" name="filtrar_cliente_por" formControlName="filtro" (change)="alterarFiltroProdutoCliente($event.target.value)">
                  @for (opcao of filtroClientes; track opcao) {
                    <option [value]="opcao.valor">{{ opcao.texto }}</option>
                  }
                </select>
              </div>
              <!-- Campo de Valor -->
              <div class="form-group col-sm-5">
                <label class="text-secondary"><b>Valor:</b></label>
                <!-- Entrada de texto para campos sem opções (código, CNPJ, nome, etc.) -->
                @if (!filtroValorClienteEhSelect) {
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    name="cliente_valor"
                    [ngClass]="{ 'is-invalid': enviadoCliente && fc.valor.errors?.required }"
                    formControlName="valor"
                    placeholder="Digite o valor" />
                }
                <!-- Select genérico para campos com opções carregadas da API -->
                @if (filtroValorClienteEhSelect) {
                  <select
                    class="form-control form-control-sm"
                    name="cliente_valor"
                    [ngClass]="{ 'is-invalid': enviadoCliente && fc.valor.errors?.required }"
                    formControlName="valor">
                    <option value="">-- Selecione --</option>
                    @for (op of opcoesValorFiltroCliente; track op) {
                      <option [value]="op">{{ op }}</option>
                    }
                  </select>
                }
                @if (enviadoCliente && fc.valor.errors?.required) {
                  <div class="erro pt-1">Valor em branco!</div>
                }
              </div>
              <div class="col-sm-5 d-flex align-items-end gap-2">
                <button class="btn btn-success btn_filtro" type="button" (click)="adicionarFiltroCliente()">+ Adicionar Filtro</button>
                <button class="btn btn-info btn_filtro" type="button" (click)="filtrarCliente()" [disabled]="filtrosAtivosClientes.length === 0">
                  Aplicar {{ filtrosAtivosClientes.length > 0 ? '(' + filtrosAtivosClientes.length + ')' : '' }}
                </button>
                @if (filtrosAtivosClientes.length > 0) {
                  <button class="btn btn-secondary btn_filtro" type="button" (click)="limparTodosFiltrosClientes()">Limpar</button>
                }
              </div>
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <!-- Cards de Filtros Ativos -->
          @if (filtrosAtivosClientes.length > 0) {
            <div style="margin-bottom: 1rem;">
              <div class="gap-2">
                @for (filtro of filtrosAtivosClientes; track filtro; let i = $index) {
                  <div class="badge badge-info w-auto">
                    <span><b>{{ obterTextoFiltroCliente(filtro.tipo) }}:</b> {{ filtro.valor }}</span>
                    <button type="button" (click)="removerFiltroCliente(i)"
                      style="background: none; border: none; color: white; cursor: pointer; padding: 0; margin-left: 0.5rem; font-size: 1rem; line-height: 1;">
                      ✕
                    </button>
                  </div>
                }
              </div>
            </div>
          }
          @if (filtrosAtivosClientes.length > 0) {
            <hr class="mt-3 mb-2" />
          }
          @if (filtrandoCliente) {
            <div [@esvanecerDesvanecer]="'in'">
              <div class="filtrar_cliente p-1">
                <div class="table-responsive h-100">
                  <cdk-virtual-scroll-viewport class="filtrar_cliente_tabela" [itemSize]="20" minBufferPx="50" maxBufferPx="200">
                    <table class="table table-hover">
                      <thead class="sticky-top bg-white">
                        <tr>
                          <th class="text-center">
                            <input type="checkbox" class="cliente-checkbox" [checked]="estaTodasClientesSelecionadas()" (change)="selecionarTodosClientes()" />
                          </th>
                          <th class="text-center">Código</th>
                          <th class="tabela_borda">Cliente</th>
                          <th class="tabela_borda text-center">CNPJ/CPF</th>
                          <th class="tabela_borda">Endereço</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *cdkVirtualFor="let cliente of clientes; templateCacheSize: 0;">
                          <tr [ngClass]="{ 'cliente-selecionado': estaClienteSelecionadoEmMassa(cliente.id) }" class="filtrar_cliente_acao" [style.cursor]="'pointer'" (click)="selecionarClienteEmMassa(cliente.id)">
                            <td class="text-center" (click)="$event.stopPropagation()">
                              <input type="checkbox" class="cliente-checkbox" [checked]="estaClienteSelecionadoEmMassa(cliente.id)" (change)="selecionarClienteEmMassa(cliente.id)" />
                            </td>
                            <td class="text-center">{{ cliente.codigo_no_erp_do_cliente }}</td>
                            <td class="tabela_borda">{{ cliente.name }}</td>
                            <td class="tabela_borda text-center">{{ cliente.client_document }}</td>
                            <td class="tabela_borda">{{ cliente.endereco_completo }}</td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </cdk-virtual-scroll-viewport>
                </div>
              </div>
              <hr class="mt-2 mb-2" />
              <!-- Seção de Importação em Massa -->
              <div class="mb-3">
                <div class="d-flex justify-content-between mb-2">
                  @if (clientesSelecionadosEmMassa.size > 0) {
                    <button class="btn btn-warning btn_formulario" type="button" (click)="abrirModalClientesAdicionadosEmMassa(clientesAdicionadosEmMassaModal)">
                      👁️ Visualizar ({{ clientesSelecionadosEmMassa.size }}) Selecionado(s)
                    </button>
                  }
                </div>
                <div class="alert alert-info p-3 mb-3">
                  <div class="form-row">
                    <div class="form-group col-sm-12 d-flex align-items-end">
                      <button class="btn btn-success btn_formulario" type="button" (click)="importarClientesSelecionados()" [disabled]="clientesSelecionadosEmMassa.size === 0">
                        ✓ Importar {{ clientesSelecionadosEmMassa.size }} Cliente(s)
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <hr class="mt-2 mb-2" />
          <!-- Cliente (Tabela Especial (Itens)) - COMPONENTE EDITÁVEL -->
          <div class="alert alert-light border p-3 mb-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center mb-2">
              <div>
                <b>Importar clientes por planilha</b>
                <small class="text-muted d-block">A planilha deve conter apenas a coluna <b>codigo_no_erp_do_cliente</b>.</small>
              </div>
              <button class="btn btn-outline-secondary btn-sm" type="button" (click)="baixarModeloImportacaoClientes()">
                Baixar modelo
              </button>
            </div>
            <div class="form-row align-items-end">
              <div class="form-group col-sm-7 mb-0">
                <input class="form-control form-control-sm" type="file" accept=".xlsx,.xls"
                  (change)="onArquivoImportacaoClientesSelecionado($event)" />
              </div>
              <div class="form-group col-sm-5 mb-0">
                <button class="btn btn-primary btn_formulario" type="button"
                  (click)="processarImportacaoClientesPlanilha()"
                  [disabled]="arquivoImportacaoClientes == null || importandoClientesPlanilha">
                  @if (importandoClientesPlanilha) { Processando... } @else { Processar planilha }
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <h5><b>Clientes Importados</b></h5>
          </div>
          <app-tabela-clientes-editavel
            [clientes]="produtosEspecialClientes"
            (clientesRemovidos)="onClientesRemovidos($event)">
          </app-tabela-clientes-editavel>
        </div>
      }
      <!-- Modal (Clientes Adicionados em Massa) -->
      <ng-template #clientesAdicionadosEmMassaModal let-modal>
        <div class="modal-header pl-3">
          <h3 class="modal-title" id="titulo-clientes-adicionados-em-massa"><b>Clientes Selecionados para Importação ({{ clientesSelecionadosEmMassa.size }})</b></h3>
          <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          @if (clientesSelecionadosEmMassa.size === 0) {
            <div class="alert alert-info">
              Nenhum cliente selecionado.
            </div>
          }
          @if (clientesSelecionadosEmMassa.size > 0) {
            <div class="table-responsive">
              <table class="table table-sm table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th class="text-center tabela_borda">Código</th>
                    <th class="tabela_borda">Cliente</th>
                    <th class="tabela_borda text-center">CNPJ/CPF</th>
                    <th class="tabela_borda">Endereço</th>
                  </tr>
                </thead>
                <tbody>
                  @for (id_cliente of clientesSelecionadosEmMassa; track id_cliente) {
                    @for (cliente of clientes | slice:0:clientes.length; track cliente) {
                      @if (cliente.id === id_cliente) {
                        <tr>
                          <td class="text-center tabela_acao">
                            <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Desselecionar" (click)="selecionarClienteEmMassa(id_cliente)"></i>
                          </td>
                          <td class="text-center tabela_borda">{{ cliente.codigo_no_erp_do_cliente }}</td>
                          <td class="tabela_borda">{{ cliente.name }}</td>
                          <td class="text-center tabela_borda">{{ cliente.client_document }}</td>
                          <td class="tabela_borda">{{ cliente.endereco_completo }}</td>
                        </tr>
                      }
                    }
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
        <div class="modal-footer flex-wrap">
          <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Fechar')">Fechar</button>
        </div>
      </ng-template>
      <ng-template #modalImportacaoClientesPlanilha let-modal>
        <div class="modal-header pl-3">
          <h3 class="modal-title" id="titulo-importacao-clientes-planilha"><b>Resultado da importacao de clientes</b></h3>
          <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="alert alert-info mb-3">
            <b>Validos:</b> {{ importacaoClientesLinhasValidas }}
            <span class="ml-3"><b>Erros/Avisos:</b> {{ importacaoClientesLinhasInvalidas }}</span>
          </div>
          <div class="table-responsive">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th class="text-center">Linha</th>
                  <th class="tabela_borda">Codigo ERP</th>
                  <th class="tabela_borda">Cliente</th>
                  <th class="tabela_borda text-center">Status</th>
                  <th class="tabela_borda">Detalhe</th>
                </tr>
              </thead>
              <tbody>
                @for (linha of linhasImportacaoClientes; track linha.linha) {
                  <tr>
                    <td class="text-center">{{ linha.linha }}</td>
                    <td class="tabela_borda">{{ linha.codigo_no_erp_do_cliente || '-' }}</td>
                    <td class="tabela_borda">{{ linha.nome || '-' }}</td>
                    <td class="tabela_borda text-center">
                      @if (linha.valido) {
                        <span class="badge badge-success">Valido</span>
                      } @else {
                        <span class="badge badge-danger">Erro</span>
                      }
                    </td>
                    <td class="tabela_borda">{{ linha.erro || 'Pronto para importar' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer flex-wrap">
          <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Fechar')">Cancelar</button>
          <button class="btn btn-success btn_formulario" type="button"
            (click)="confirmarImportacaoClientesPlanilha(modal)"
            [disabled]="importacaoClientesLinhasValidas === 0">
            Importar {{ importacaoClientesLinhasValidas }} cliente(s)
          </button>
        </div>
      </ng-template>
      <!-- Vendedores -->
      @if (itemSelecionado == 3) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <div class="d-flex flex-wrap justify-content-between">
            <div class="flex-grow-1 formulario_rodape">
              <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(3)">Retornar</button>
            </div>
            <div class="flex-grow-1 formulario_rodape text-right">
              <!-- <button class="btn btn-secondary btn_formulario" type="button" (click)="prosseguirItemSelecionado(3)">Prosseguir</button> -->
              <button class="btn btn-success btn_formulario btn_formulario_save" type="button" (click)="salvarProdutoTabelaEspecial()">Salvar (Promoção)</button>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
          <!-- Buscar (Vendedor) - Múltiplos Filtros -->
          <form [formGroup]="formFiltroVendedor" (ngSubmit)="adicionarFiltroVendedor()">
            <div class="form-row">
              <div class="form-group col-sm-2">
                <label class="text-secondary"><b>Filtrar por:</b></label>
                <select class="form-control form-control-sm" name="filtrar_vendedor_por" formControlName="filtro" (change)="alterarFiltroVendedorTipo($event.target.value)">
                  @for (opcao of filtroVendedores; track opcao) {
                    <option [value]="opcao.valor">{{ opcao.texto }}</option>
                  }
                </select>
              </div>
              <!-- Campo de Valor -->
              <div class="form-group col-sm-5">
                <label class="text-secondary"><b>Valor:</b></label>
                <!-- Entrada para Código e Nome -->
                @if (fv.filtro.value !== 'empresa') {
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    name="vendedor_valor"
                    [ngClass]="{ 'is-invalid': enviadoVendedor && fv.valor.errors?.required }"
                    formControlName="valor"
                    placeholder="Digite o valor" />
                }
                <!-- Select para Empresa (dinâmico) -->
                @if (fv.filtro.value === 'empresa') {
                  <select
                    class="form-control form-control-sm"
                    name="vendedor_empresa"
                    [ngClass]="{ 'is-invalid': enviadoVendedor && fv.valor.errors?.required }"
                    formControlName="valor">
                    <option value="">-- Selecione uma empresa --</option>
                    @for (empresa of empresasDisponiveis; track empresa) {
                      <option [value]="empresa">{{ empresa }}</option>
                    }
                  </select>
                }
                @if (enviadoVendedor && fv.valor.errors?.required) {
                  <div class="erro pt-1">Valor em branco!</div>
                }
              </div>
              <div class="col-sm-5 d-flex align-items-end gap-2">
                <button class="btn btn-success btn_filtro" type="button" (click)="adicionarFiltroVendedor()">+ Adicionar Filtro</button>
                <button class="btn btn-info btn_filtro" type="button" (click)="filtrarVendedor()" [disabled]="filtrosAtivosVendedores.length === 0">
                  Aplicar {{ filtrosAtivosVendedores.length > 0 ? '(' + filtrosAtivosVendedores.length + ')' : '' }}
                </button>
                @if (filtrosAtivosVendedores.length > 0) {
                  <button class="btn btn-secondary btn_filtro" type="button" (click)="limparTodosFiltrosVendedores()">Limpar</button>
                }
              </div>
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <!-- Cards de Filtros Ativos -->
          @if (filtrosAtivosVendedores.length > 0) {
            <div style="margin-bottom: 1rem;">
              <div class="gap-2">
                @for (filtro of filtrosAtivosVendedores; track filtro; let i = $index) {
                  <div class="badge badge-info w-auto">
                    <span><b>{{ obterTextoFiltroVendedor(filtro.tipo) }}:</b> {{ filtro.valor }}</span>
                    <button type="button" (click)="removerFiltroVendedor(i)"
                      style="background: none; border: none; color: white; cursor: pointer; padding: 0; margin-left: 0.5rem; font-size: 1rem; line-height: 1;">
                      ✕
                    </button>
                  </div>
                }
              </div>
            </div>
          }
          @if (filtrosAtivosVendedores.length > 0) {
            <hr class="mt-3 mb-2" />
          }
          @if (filtrandoVendedor) {
            <div [@esvanecerDesvanecer]="'in'">
              <div class="filtrar_vendedor p-1">
                <div class="table-responsive h-100">
                  <cdk-virtual-scroll-viewport class="filtrar_vendedor_tabela" [itemSize]="20" minBufferPx="50" maxBufferPx="200">
                    <table class="table table-hover">
                      <thead class="sticky-top bg-white">
                        <tr>
                          <th class="text-center">
                            <input type="checkbox" class="vendedor-checkbox" [checked]="estaTodasVendedoresSelecionadas()" (change)="selecionarTodosVendedores()" />
                          </th>
                          <th class="text-center">Código</th>
                          <th class="tabela_borda">Vendedor(a)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *cdkVirtualFor="let vendedor of vendedores; templateCacheSize: 0;">
                          <tr [ngClass]="{ 'vendedor-selecionado': estaVendedorSelecionadoEmMassa(vendedor.id) }" class="filtrar_vendedor_acao" [style.cursor]="'pointer'" (click)="selecionarVendedorEmMassa(vendedor.id)">
                            <td class="text-center" (click)="$event.stopPropagation()">
                              <input type="checkbox" class="vendedor-checkbox" [checked]="estaVendedorSelecionadoEmMassa(vendedor.id)" (change)="selecionarVendedorEmMassa(vendedor.id)" />
                            </td>
                            <td class="text-center">{{ vendedor.codigo_no_erp_do_cliente }}</td>
                            <td class="tabela_borda">{{ vendedor.fullname }}</td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </cdk-virtual-scroll-viewport>
                </div>
              </div>
              <hr class="mt-2 mb-2" />
              <!-- Seção de Importação em Massa -->
              <div class="mb-3">
                <div class="d-flex justify-content-between mb-2">
                  @if (vendedoresSelecionadosEmMassa.size > 0) {
                    <button class="btn btn-warning btn_formulario" type="button" (click)="abrirModalVendedoresAdicionadosEmMassa(vendedoresAdicionadosEmMassaModal)">
                      👁️ Visualizar ({{ vendedoresSelecionadosEmMassa.size }}) Selecionado(s)
                    </button>
                  }
                </div>
                <div class="alert alert-info p-3 mb-3">
                  <div class="form-row">
                    <div class="form-group col-sm-12 d-flex align-items-end">
                      <button class="btn btn-success btn_formulario" type="button" (click)="importarVendedoresSelecionados()" [disabled]="vendedoresSelecionadosEmMassa.size === 0">
                        ✓ Importar {{ vendedoresSelecionadosEmMassa.size }} Vendedor(a)(s)
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <hr class="mt-2 mb-2" />
          <!-- Vendedor (Tabela Especial (Itens)) - COMPONENTE EDITÁVEL -->
          <div class="mb-3">
            <h5><b>Vendedores Importados</b></h5>
          </div>
          <app-tabela-vendedores-editavel
            [vendedores]="produtosEspecialVendedores"
            (vendedoresChange)="produtosEspecialVendedores = $event">
          </app-tabela-vendedores-editavel>
        </div>
      }
      <!-- Step 4: Regras de Grupo -->
      @if (itemSelecionado == 4) {
        <div class="pr-4 pb-4 pl-4">
          <div class="d-flex flex-wrap justify-content-between">
            <div class="flex-grow-1 formulario_rodape">
              <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(4)">Retornar</button>
            </div>
            <div class="flex-grow-1 formulario_rodape text-right">
              <button class="btn btn-success btn_formulario btn_formulario_save" type="button" (click)="salvarProdutoTabelaEspecial()">Salvar (Promoção)</button>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
          @if (regrasGrupoCarregando) {
            <div class="text-center py-3"><i class="fas fa-spinner fa-spin"></i> Carregando...</div>
          }

          <!-- Clientes por Grupo -->
          <h6 class="font-weight-bold mb-2">Clientes por Grupo</h6>
          <div class="form-row align-items-end mb-2">
            <div class="col-auto">
              <select class="form-control form-control-sm" [(ngModel)]="rgCampoCliente" (change)="carregarValoresCliente()">
                <option value="">Campo...</option>
                @for (c of camposCliente; track c.campo) {
                  <option [value]="c.campo">{{ c.label }}</option>
                }
              </select>
            </div>
            <div class="col-auto">
              <select class="form-control form-control-sm" [(ngModel)]="rgValorCliente"
                [disabled]="!rgCampoCliente || rgValoresClienteCarregando">
                <option value="">{{ rgValoresClienteCarregando ? 'Carregando...' : 'Valor...' }}</option>
                @for (v of rgValoresCliente; track v) {
                  <option [value]="v">{{ v }}</option>
                }
              </select>
            </div>
            <div class="col-auto">
              <button class="btn btn-sm btn-primary" [disabled]="!rgCampoCliente || !rgValorCliente"
                (click)="adicionarRegraGrupoCliente()">
                <i class="fas fa-plus"></i> Adicionar
              </button>
            </div>
          </div>
          <div class="table-responsive tabela-grid mb-4">
            <table class="table table-sm table-hover mb-0">
              <thead><tr><th>Campo</th><th>Valor</th><th></th></tr></thead>
              <tbody>
                @for (r of regrasGrupoClientes; track r.id) {
                  <tr>
                    <td>{{ r.campo }}</td><td>{{ r.valor }}</td>
                    <td class="text-right">
                      <button class="btn btn-link btn-link-action danger" type="button" title="Remover regra" (click)="removerRegraGrupo(r.id)"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                } @empty {
                  <tr><td colspan="3" class="text-center text-muted py-2">Nenhuma regra de cliente cadastrada.</td></tr>
                }
              </tbody>
            </table>
          </div>

          <!-- Produtos por Grupo -->
          <h6 class="font-weight-bold mb-2">Produtos por Grupo</h6>
          <div class="form-row align-items-end mb-2">
            <div class="col-auto">
              <select class="form-control form-control-sm" [(ngModel)]="rgCampoProduto" (change)="carregarValoresProduto()">
                <option value="">Campo...</option>
                @for (c of camposProduto; track c.campo) {
                  <option [value]="c.campo">{{ c.label }}</option>
                }
              </select>
            </div>
            <div class="col-auto">
              <select class="form-control form-control-sm" [(ngModel)]="rgValorProduto"
                [disabled]="!rgCampoProduto || rgValoresProdutoCarregando">
                <option value="">{{ rgValoresProdutoCarregando ? 'Carregando...' : 'Valor...' }}</option>
                @for (v of rgValoresProduto; track v) {
                  <option [value]="v">{{ v }}</option>
                }
              </select>
            </div>
            <div class="col-auto">
              <input class="form-control form-control-sm" type="number" min="1" placeholder="Qtd"
                [(ngModel)]="rgQtdProduto" style="width:70px" />
            </div>
            <div class="col-auto">
              <select class="form-control form-control-sm" [(ngModel)]="rgTipoProduto">
                <option value="">Tipo...</option>
                <option value="desconto">Desconto</option>
                <option value="margem">Margem</option>
              </select>
            </div>
            <div class="col-auto">
              <input class="form-control form-control-sm" type="number" min="0" max="100" step="0.01"
                placeholder="%" [(ngModel)]="rgPercentualProduto" style="width:70px" />
            </div>
            <div class="col-auto">
              <button class="btn btn-sm btn-primary"
                [disabled]="!rgCampoProduto || !rgValorProduto || !rgQtdProduto || !rgTipoProduto || rgPercentualProduto == null"
                (click)="adicionarRegraGrupoProduto()">
                <i class="fas fa-plus"></i> Adicionar
              </button>
            </div>
          </div>
          <div class="table-responsive tabela-grid">
            <table class="table table-sm table-hover mb-0">
              <thead><tr><th>Campo</th><th>Valor</th><th>Qtd</th><th>Tipo</th><th>%</th><th></th></tr></thead>
              <tbody>
                @for (r of regrasGrupoProdutos; track r.id) {
                  <tr>
                    <td>{{ r.campo }}</td><td>{{ r.valor }}</td>
                    <td>{{ r.qtd }}</td>
                    <td>{{ r.tipo_preco }}</td>
                    <td>{{ r.percentual }}%</td>
                    <td class="text-right">
                      <button class="btn btn-link btn-link-action danger" type="button" title="Remover regra" (click)="removerRegraGrupo(r.id)"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                } @empty {
                  <tr><td colspan="3" class="text-center text-muted py-2">Nenhuma regra de produto cadastrada.</td></tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      <!-- Modal (Vendedores Adicionados em Massa) -->
      <ng-template #vendedoresAdicionadosEmMassaModal let-modal>
        <div class="modal-header pl-3">
          <h3 class="modal-title" id="titulo-vendedores-adicionados-em-massa"><b>Vendedores Selecionados para Importação ({{ vendedoresSelecionadosEmMassa.size }})</b></h3>
          <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          @if (vendedoresSelecionadosEmMassa.size === 0) {
            <div class="alert alert-info">
              Nenhum vendedor(a) selecionado(a).
            </div>
          }
          @if (vendedoresSelecionadosEmMassa.size > 0) {
            <div class="table-responsive">
              <table class="table table-sm table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th class="text-center tabela_borda">Código</th>
                    <th class="tabela_borda">Vendedor(a)</th>
                  </tr>
                </thead>
                <tbody>
                  @for (id_vendedor of vendedoresSelecionadosEmMassa; track id_vendedor) {
                    @for (vendedor of vendedores | slice:0:vendedores.length; track vendedor) {
                      @if (vendedor.id === id_vendedor) {
                        <tr>
                          <td class="text-center tabela_acao">
                            <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Desselecionar" (click)="selecionarVendedorEmMassa(id_vendedor)"></i>
                          </td>
                          <td class="text-center tabela_borda">{{ vendedor.codigo_no_erp_do_cliente }}</td>
                          <td class="tabela_borda">{{ vendedor.fullname }}</td>
                        </tr>
                      }
                    }
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
        <div class="modal-footer flex-wrap">
          <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Fechar')">Fechar</button>
        </div>
      </ng-template>
    </div>
  }
</div>

<!-- ===== Modal: Log de uso de UM item (cota) ===== -->
<ng-template #modalLogItem let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Log de uso — {{ logItemProdutoNome }}</h5>
    <button type="button" class="close" aria-label="Fechar" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    @if (carregandoLogItem) {
      <p class="text-center text-muted my-3">Carregando...</p>
    } @else if (logItemLinhas.length === 0) {
      <p class="text-center text-muted my-3">Nenhum uso registrado para este item.</p>
    } @else {
      <div class="table-responsive">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>Data</th>
              <th class="text-center">Pedido</th>
              <th>Vendedor</th>
              <th>Cliente</th>
              <th class="text-right">Qtd</th>
            </tr>
          </thead>
          <tbody>
            @for (l of logItemLinhas; track l.id) {
              <tr>
                <td>{{ l.data_hora | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td class="text-center">{{ l.order_id_app }}</td>
                <td>{{ l.seller_nome }}</td>
                <td>{{ l.client_nome }}</td>
                <td class="text-right">{{ l.quantidade | number: '1.0-2' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" type="button" (click)="modal.close()">Fechar</button>
  </div>
</ng-template>

<!-- ===== Modal: Diagnóstico de uso da promoção ===== -->
<ng-template #modalDiagnostico let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Diagnóstico de uso da promoção</h5>
    <button type="button" class="close" aria-label="Fechar" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    @if (carregandoDiagnostico) {
      <p class="text-center text-muted my-3">Carregando...</p>
    } @else {
      <!-- Filtros -->
      <div class="form-row mb-2">
        <div class="form-group col-sm-5">
          <label class="text-secondary"><b>Vendedor</b></label>
          <select class="form-control form-control-sm" [(ngModel)]="diagFiltroSeller" (change)="aplicarFiltroDiagnostico()">
            <option [ngValue]="null">Todos</option>
            @for (v of diagnosticoVendedores; track v.id) {
              <option [ngValue]="v.id">{{ v.nome }}</option>
            }
          </select>
        </div>
        <div class="form-group col-sm-5">
          <label class="text-secondary"><b>Cliente</b></label>
          <select class="form-control form-control-sm" [(ngModel)]="diagFiltroClient" (change)="aplicarFiltroDiagnostico()">
            <option [ngValue]="null">Todos</option>
            @for (c of diagnosticoClientes; track c.id) {
              <option [ngValue]="c.id">{{ c.nome }}</option>
            }
          </select>
        </div>
      </div>

      <!-- Totais -->
      <div class="form-row mb-3">
        <div class="col-sm-4">
          <div class="border rounded p-2 text-center">
            <small class="text-muted d-block">Qtd consumida</small>
            <b>{{ diagnosticoQtdTotal | number: '1.0-2' }}</b>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="border rounded p-2 text-center">
            <small class="text-muted d-block">Pedidos</small>
            <b>{{ diagnosticoQtdPedidos }}</b>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="border rounded p-2 text-center">
            <small class="text-muted d-block">Clientes</small>
            <b>{{ diagnosticoQtdClientes }}</b>
          </div>
        </div>
      </div>

      <!-- Detalhe -->
      @if (diagnosticoFiltradas.length === 0) {
        <p class="text-center text-muted my-3">Nenhum uso registrado.</p>
      } @else {
        <div class="table-responsive">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th>Data</th>
                <th class="text-center">Pedido</th>
                <th>Produto</th>
                <th>Vendedor</th>
                <th>Cliente</th>
                <th class="text-right">Qtd</th>
              </tr>
            </thead>
            <tbody>
              @for (l of diagnosticoFiltradas; track l.id) {
                <tr>
                  <td>{{ l.data_hora | date: 'dd/MM/yyyy HH:mm' }}</td>
                  <td class="text-center">{{ l.order_id_app }}</td>
                  <td>{{ l.produto_nome }}</td>
                  <td>{{ l.seller_nome }}</td>
                  <td>{{ l.client_nome }}</td>
                  <td class="text-right">{{ l.quantidade | number: '1.0-2' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" type="button" (click)="modal.close()">Fechar</button>
  </div>
</ng-template>
